import { config } from '~/config';
import { validateApiFetch } from '~/shared/services/api-fetch/validate-api-fetch/validateApiFetch';

import { ChartPriceSchema, chartPriceSchema } from './chart-schema';

export const chartEndpoint = {
  price: `${config.api.root}price-history/v1/prices`,
  marketClose: `${config.api.root}price-history/v1/market-close`,
};

export type Resolution = `${number}${'m' | 'h' | 'D' | 'W' | 'M' | 'Y'}`;

export const chartEndpoints = {
  getPrice: chartEndpoint.price,
};

export interface GetPriceProps {
  ticker: string;
  entityTag: string;
  resolution: Resolution;
  dateFrom: string;
  dateTo: string;
}

export const getPrice = async ({
  ticker,
  entityTag,
  resolution,
  dateFrom,
  dateTo,
}: GetPriceProps): Promise<ChartPriceSchema> => {
  const priceUrl = new URL(chartEndpoints.getPrice);
  priceUrl.searchParams.append('ticker', ticker);
  priceUrl.searchParams.append('entity_tag', entityTag);
  priceUrl.searchParams.append('resolution', resolution);
  priceUrl.searchParams.append('from', dateFrom);
  priceUrl.searchParams.append('to', dateTo);

  return validateApiFetch({
    endpoint: priceUrl.href,
    schema: chartPriceSchema,
  });
};
